import * as React from 'react';
import styles from './style.scss';
import CSSModules from "react-css-modules";
import PropTypes from "prop-types";
import button from "../../components/common/material/Button";

@CSSModules(styles, {allowMultiple: true})
export class SmallContinueBanner extends React.Component {

  static propTypes = {
    formatMessage: PropTypes.func.isRequired,
    continueClicked: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {width: 0, height: 0};
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({width: window.innerWidth, height: window.innerHeight});
  }

  render() {
    const {formatMessage, continueClicked, onClose} = this.props;

    return (
      <div styleName="container" data-at="continue-card-application-modal">
        <div styleName="closeContainer">
          <img src={'/static/images/close24px.png'} onClick={onClose}/>
        </div>
        <div styleName="body-container">
          <div styleName="imgWithHeader">
            <div styleName="imgContainer">
              <img styleName="cardImg" src={'/static/images/blue-card.png'}/>
            </div>
            <div styleName="header" data-at="card-application-continue-header">{formatMessage({id: "purchase.banner.unfinishedApplication"})}</div>
          </div>
          <div styleName="applyNowButtonContainer">
            <button styleName="applyButton" data-at="continue-card-application-button" onClick={continueClicked}>{formatMessage({id: "purchase.banner.continue"})}</button>
          </div>
        </div>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/purchases/smallContinueBanner/smallContinueBanner.js